import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React from 'react';
import { getStarValues } from './helpers/get-star-values.esm.js';
import { StarRatingFilter } from './helpers/star-rating-filter.esm.js';
import { StarRatingUI } from './helpers/star-rating-ui.esm.js';

var _excluded = ["value", "onClick", "variant"];
var defaultValue = 0;
var defaultMaxRating = 5;
var defaultVariant = 'md';
function StarRating(props) {
  var _props$value = props.value,
    value = _props$value === void 0 ? defaultValue : _props$value,
    onClick = props.onClick,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? defaultVariant : _props$variant,
    rest = _objectWithoutProperties(props, _excluded);
  //guard clause is for perf
  if (!onClick) {
    var valueArray = getStarValues(value, defaultMaxRating);
    return /*#__PURE__*/React.createElement(StarRatingUI, _extends({
      valueArray: valueArray,
      variant: variant
    }, rest));
  }
  return /*#__PURE__*/React.createElement(StarRatingFilter, _extends({
    variant: variant
  }, props));
}

export { StarRating as default };
//# sourceMappingURL=star-rating.esm.js.map
